/**
 * Restore-gate: разрешение писать layout появляется только после того, как для этого
 * проекта уже отработал LAYOUT_RESTORE.
 *
 * Зачем: редьюсер `PROJECT_SET` отрабатывает РАНЬШЕ саги, поэтому существует окно,
 * в котором `editor.project.id` — уже новый, а `contentWindows` — ещё от предыдущего
 * проекта. Запись в этом окне затрёт сохранённое состояние нового проекта окнами
 * старого. Трейлинг-throttle это окно закрывает лишь случайно — достаточно поменять
 * его на leading или вставить `yield` перед `put`, чтобы фича начала молча терять
 * данные. Гейт делает корректность структурной, а не зависящей от планировщика.
 */
let restoredProjectId: string | null = null;

export function markLayoutRestored(projectId: string): void {
  restoredProjectId = projectId;
}

export function getRestoredProjectId(): string | null {
  return restoredProjectId;
}

export function resetLayoutRestoreGate(): void {
  restoredProjectId = null;
}
